import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ClientImplementationRepositoryMapper } from './mappers/client-repository.mapper';
import { ClientRepository } from '../../../domain/repositories/client.repository';
import { ClientModel } from '../../../domain/models/client/client.model';
import { ClientEntity, DataClientEntity } from './entities/client.entity';


@Injectable({
    providedIn: 'root',
})
export class ClientImplementationRepository extends ClientRepository {
    ClientMapper1 = new ClientImplementationRepositoryMapper();
    ClientMapper2 = new ClientImplementationRepositoryMapper();
    ClientMapper3 = new ClientImplementationRepositoryMapper();
    ClientMapper4 = new ClientImplementationRepositoryMapper();
    ClientMapper5 = new ClientImplementationRepositoryMapper();
    url = environment.baseUrl;
    constructor(private http: HttpClient) {
        super();
    }

    override getClientAll(): Observable<ClientModel> {
        return this.http.get(`${this.url}/Clientes/GetAllByUserId`)
        .pipe(map(this.ClientMapper1.mapFrom));
    }
    
    override getClientAllByKeyword(params: {Keyword:string}): Observable<ClientModel> {
        return this.http.get(`${this.url}/Clientes/GetAllByKeyword/${params.Keyword}`)
        .pipe(map(this.ClientMapper2.mapFrom));
    }

    override getClientAllById(params: {Id:string}): Observable<ClientModel> {
        return this.http.get(`${this.url}/Clientes/GetById/${params.Id}`)
        .pipe(map(this.ClientMapper3.mapFrom));
    }

    override statusClient(params: {Id: string}): Observable<ClientModel> {
        return this.http.delete(`${this.url}/Clientes/Delete/${params.Id}`)
        .pipe(map(this.ClientMapper4.mapFrom));
    }

    override insertClient(params: DataClientEntity): Observable<ClientModel> {
        return this.http.post<ClientEntity>(`${this.url}/Clientes/Insert`,params)
        .pipe(map(this.ClientMapper5.mapFrom));
    }

    override updateClient(params: DataClientEntity): Observable<ClientModel> {
        return this.http.put<ClientEntity>(`${this.url}/Clientes/Update`,params)
        .pipe(map(this.ClientMapper5.mapFrom));
    }

}